import type { AxiosInstance } from 'axios';
import { BaseService } from './BaseService';
import type {
  NotificationTypeViewModel,
  NotificationTypeCreateModel,
  NotificationTypeUpdateModel,
} from '../types/notification-type';
import { apiClient } from '../client/client';

export class NotificationTypeService extends BaseService<
  NotificationTypeViewModel,
  NotificationTypeCreateModel,
  NotificationTypeUpdateModel,
  NotificationTypeViewModel[]
> {
  private static readonly BASE = '/api/notification-type';

  constructor(client: AxiosInstance = apiClient) {
    super(client, NotificationTypeService.BASE);
  }
}

export const notificationTypeService = new NotificationTypeService();
